var React = require('react');

function Html5Inline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M56.89 23.272l.806-8.684H13.19l2.367 26.498h30.811L45.26 52.399l-9.918 2.63-9.867-2.63-.655-6.947h-8.81l1.107 13.795 18.225 4.962h.202v-.05l18.074-4.912 2.517-26.994H23.713l-.756-8.981H56.89zM0 0h70.886l-6.444 71.354-29.1 8.038-28.898-8.038L0 0z"}));
}

Html5Inline.defaultProps = {"viewBox":"0 0 71 80"};

module.exports = Html5Inline;

Html5Inline.default = Html5Inline;
